import store from '@/store';

export default (to, from, next) => {
    return {
        allow: store.getters.is_sign_up_allowed,
        redirect: { name: 'eshop-checkout' },
    }
};
